module.exports = __webpack_public_path__ + "static/media/icon-pdf.1840f95a.svg";